import q from 'q'
import superagent from 'superagent'
import metrics from './metrics'

const REQUEST_TIMEOUT = 60000
const ENDPOINT = 'https://geoservice.smarttech.com/'
const API_KEY = 'EJvtnqbBummCNZlYCUByL0X5NvfxloQDs4Z01R1Y'

/**
 * resolves the users location
 */
let resolveLocation = () => {
  let deferred = q.defer()
  let request = superagent('GET', ENDPOINT)
  request.timeout(REQUEST_TIMEOUT)
  request.set('X-API-Key', API_KEY)
  request.set('Content-Type', 'application/json')
  request.accept('application/json')
  request.end(function (error, response) {
    if (error) {
      deferred.reject(error)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.FETCH_LOCATION_ERROR, 1, metrics.TYPE.FAILURE_COUNTER, error)
    } else {
      deferred.resolve(response)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.FETCH_LOCATION_SUCCESS, 1, metrics.TYPE.OCCURRENCE_COUNTER)
    }
  })
  return deferred.promise
}

export default {
  resolveLocation
}
